/**
 * @file コンポーネント：フル動画ページスレッドポップアップカード ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const PopupThreadCard = (props) => {
    const refBody = useRef(null);
    useEffect(() => {
        if (refBody !== null && refBody.current !== null) {
            const links = refBody.current.querySelectorAll("a");
            for (const link of links) {
                link.addEventListener("click", (e) => {
                    e.preventDefault();
                    const time = link.dataset.time;
                    props.fnJump(time);
                });
            }
        }
    }, [props.text, refBody]);

    // Presenterに渡す
    return <Presenter {...props} refBody={refBody} />;
};
